import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'app-search-results-top',
  templateUrl: './search-results-top.component.html',
  styleUrls: ['./search-results-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchResultsTopComponent {
  @Input() top: any;

  @Output() profileConnect = new EventEmitter<number>();
  @Output() profileDisconnect = new EventEmitter<number>();

  @Output() organizationFollow = new EventEmitter<number>();
  @Output() organizationUnfollow = new EventEmitter<number>();

  @Output() seeMore = new EventEmitter<string>();

  onProfileConnect(id: number) {
    this.profileConnect.emit(id);
  }

  onProfileDisconnect(id: number) {
    this.profileDisconnect.emit(id);
  }

  onOrganizationFollow(id: number) {
    this.organizationFollow.emit(id);
  }

  onOrganizationUnfollow(id: number) {
    this.organizationUnfollow.emit(id);
  }

  onSeeMore(type) {
    this.seeMore.emit(type);
  }
}
